import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { LoggedOutLayout } from 'containers';
import { LoginForm, Spinner } from 'components';
import * as authActions from 'redux/modules/auth';
import { loadUserTypeFromLogin } from 'redux/modules/config';
var Login = (_dec = connect(function (state) {
  return {
    user: state.auth.user
  };
}, _objectSpread(_objectSpread({}, authActions), {}, {
  loadUserTypeFromLogin: loadUserTypeFromLogin
})), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(Login, _Component);

  var _super = _createSuper(Login);

  function Login() {
    var _this;

    _classCallCheck(this, Login);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "login", function (data) {
      return _this.props.login(data).then(_this.successLogin);
    });

    _defineProperty(_assertThisInitialized(_this), "successLogin", function (response) {
      _this.props.loadUserTypeFromLogin(response.userTypeInfo);

      return response;
    });

    return _this;
  }

  _createClass(Login, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          user = _this$props.user,
          logout = _this$props.logout;
      return /*#__PURE__*/React.createElement(LoggedOutLayout, {
        showBg: true
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Login"
      }), !user && /*#__PURE__*/React.createElement(LoginForm, {
        onSubmit: this.login
      }), user && /*#__PURE__*/React.createElement("div", {
        style: {
          height: '100%'
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })));
    }
  }]);

  return Login;
}(Component), _defineProperty(_class2, "propTypes", {
  user: PropTypes.object,
  login: PropTypes.func,
  logout: PropTypes.func
}), _defineProperty(_class2, "contextTypes", {
  router: PropTypes.object
}), _temp)) || _class);
export { Login as default };